import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiBell, FiBellOff, FiEdit2, FiMessageCircle, FiSearch, FiUsers, FiSun, FiMoon } = FiIcons;

const TELEGRAM_URL = "https://t.me/+JCydp2RKvl1iZTI5";

export default function ChatHeader({
  mode,
  onModeChange,
  unreadPrivateCount,
  notificationsEnabled,
  onToggleNotifications,
  search,
  onSearchChange,
  onChangeNickname,
  theme,
  toggleTheme
}) {
  return (
    <div className="shrink-0 border-b border-gray-200 dark:border-white/5 bg-white dark:bg-[#111] transition-colors">
      <div className="flex items-center justify-between gap-1.5 px-2 py-1.5 sm:px-3 sm:py-2">
        
        {/* Botón de Peleas (Telegram Oficial) con Efecto de Atención y Brillo */}
        <a
          href={TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          title="¡Ver peleas y unirse al grupo de Telegram!"
          className="group relative flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#0088cc] via-[#24A1DE] to-[#0077b5] px-2.5 py-1 text-[11px] font-bold text-white shadow-md shadow-[#0088cc]/30 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-[#0088cc]/50 active:scale-95 animate-pulse hover:animate-none overflow-hidden"
        >
          {/* Efecto de destello de luz recorriendo el botón */}
          <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/25 to-transparent pointer-events-none" />
          
          {/* Icono Vectorial Oficial de Telegram */}
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            className="h-3.5 w-3.5 shrink-0 group-hover:rotate-12 transition-transform duration-300 drop-shadow"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.75-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
          </svg>

          <span className="truncate tracking-wide font-extrabold flex items-center gap-1">
            Peleas
          </span>

          {/* Indicador de Nuevo / Enlace Activo */}
          <span className="relative flex h-1.5 w-1.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-90"></span>
            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white"></span>
          </span>
        </a>

        {/* Selector de Pestañas: General / Privado */}
        <div className="flex flex-1 items-center justify-center px-1">
          <div className="flex w-full max-w-[190px] items-center gap-0.5 rounded-md bg-gray-100 dark:bg-black/40 p-0.5 border border-gray-200/50 dark:border-transparent">
            <button
              type="button"
              onClick={() => onModeChange('public')}
              className={`flex-1 rounded py-1 sm:py-1.5 text-[10px] sm:text-xs font-semibold transition-all ${
                mode === 'public'
                  ? 'bg-red-600 text-white shadow'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-950 dark:hover:text-white'
              }`}
            >
              <span className="hidden sm:inline-block mr-1"><SafeIcon icon={FiUsers} size={12} /></span>
              General
            </button>
            <button
              type="button"
              onClick={() => onModeChange('private')}
              className={`relative flex-1 rounded py-1 sm:py-1.5 text-[10px] sm:text-xs font-semibold transition-all ${
                mode === 'private'
                  ? 'bg-red-600 text-white shadow'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-950 dark:hover:text-white'
              }`}
            >
              <span className="hidden sm:inline-block mr-1"><SafeIcon icon={FiMessageCircle} size={12} /></span>
              Privado
              {unreadPrivateCount > 0 && (
                <span className="absolute -right-1 -top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-red-600 text-[8px] font-bold text-white">
                  {unreadPrivateCount > 99 ? '99' : unreadPrivateCount}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Botones de Acción de la Cabecera */}
        <div className="flex items-center gap-0.5 sm:gap-1">
          {toggleTheme && (
            <button
              type="button"
              onClick={toggleTheme}
              title={theme === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
              className="rounded p-1.5 sm:p-2 text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-white/5 hover:text-gray-950 dark:hover:text-white transition-colors"
            >
              <SafeIcon icon={theme === 'dark' ? FiSun : FiMoon} size={14} />
            </button>
          )}
          <button
            type="button"
            onClick={onToggleNotifications}
            className={`rounded p-1.5 sm:p-2 transition-colors ${
              notificationsEnabled
                ? 'bg-red-500/10 text-red-600 dark:text-red-500'
                : 'text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-white/5 hover:text-gray-950 dark:hover:text-white'
            }`}
          >
            <SafeIcon icon={notificationsEnabled ? FiBell : FiBellOff} size={14} />
          </button>
          <button
            type="button"
            onClick={onChangeNickname}
            className="rounded p-1.5 sm:p-2 text-gray-400 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/5 hover:text-gray-950 dark:hover:text-white"
          >
            <SafeIcon icon={FiEdit2} size={14} />
          </button>
        </div>
      </div>

      {/* Buscador de Mensajes */}
      <div className="flex items-center gap-2 border-t border-gray-100 dark:border-white/5 bg-gray-50 dark:bg-[#0a0a0a] px-2 py-1 sm:px-3 sm:py-1.5">
        <SafeIcon icon={FiSearch} size={12} className="text-gray-400 dark:text-gray-500" />
        <input
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={mode === 'private' ? 'Buscar en privado...' : 'Buscar en general...'}
          className="w-full bg-transparent text-[11px] sm:text-xs text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-600 focus:outline-none"
        />
      </div>
    </div>
  );
}